module.exports = __webpack_public_path__ + "static/media/House4.a80c6db9.svg";